const formatHeaderToken = (value: string) => {
  const token = value.trim()
  const lower = token.toLowerCase()

  if (lower === 'sku') return 'SKU'
  if (lower === 'id') return 'ID'
  if (lower === 'api') return 'API'
  if (lower === 'erp') return 'ERP'
  if (lower === 'oms') return 'Oms'
  if (lower === 'gtin') return 'GTIN'
  if (lower === 'ean') return 'EAN'

  return lower.charAt(0).toUpperCase() + lower.slice(1)
}

export const formatColumnHeaderLabel = (label: string) => {
  const rawLabel = (label || '').trim()
  if (!rawLabel) return ''

  if (!/[_-]/.test(rawLabel)) {
    return rawLabel
  }

  return rawLabel
    .replace(/[_-]+/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map(formatHeaderToken)
    .join(' ')
}
